module.exports = __webpack_public_path__ + "img/Frame4344.c51fe415.png";